import { useState } from "react";
import "./DeletePlanModal.css";

import { useAppContext } from "../../../classes/contexts/AppContext";
import { useNotification } from "../../../classes/contexts/NotificationContext";
import { SnackbarType } from "../../../classes/enums/SnackbarTypeEnum";
import Button from "../../../components/button/Button";
import WarningIcon from "../../../components/icons/WarningIcon";
import IconButton from "../../../components/iconButton/IconButton";
import IconsEnum from "../../../classes/enums/IconsEnum";
import useTranslation from "../../../hooks/i18n/useTranslation";
import { deletePlan } from "../../../services/PlanService";

const DeletePlanModal = ({ plan, onPlanDeleted }) => {
  const [isDeleting, setIsDeleting] = useState(false);
  const { t } = useTranslation();
  const { hidePopup } = useAppContext();
  const { addNotification } = useNotification();

  const handleConfirm = async () => {
    if (isDeleting) return;
    setIsDeleting(true);
    try {
      await deletePlan(plan._id);
      if (onPlanDeleted) onPlanDeleted(plan._id);
      hidePopup();
    } catch (error) {
      addNotification(SnackbarType.ERROR, error.message);
      setIsDeleting(false);
    }
  };

  const handleClose = () => {
    if (!isDeleting) hidePopup();
  };

  return (
    <div className="App-module-delete-plan-modal-container">
      <div className="App-module-delete-plan-modal-close">
        <IconButton
          icon={IconsEnum.CLOSE}
          onClick={handleClose}
          noBgColor={true}
          disabled={isDeleting}
          title={t("43")}
        />
      </div>
      <div className="App-module-delete-plan-modal-header">
        <WarningIcon />
        <h2>Delete Plan</h2>
      </div>
      <div className="App-module-delete-plan-modal-body">
        <p className="confirmation-question">
          Are you sure you want to delete{" "}
          <strong>{plan.name || "this plan"}</strong>?
        </p>
      </div>
      <div className="App-module-delete-plan-modal-actions">
        <Button
          value={t("4")}
          disabled={isDeleting}
          onClick={handleConfirm}
          className="delete-button"
        />
      </div>
    </div>
  );
};

export default DeletePlanModal;
